import React from 'react'

function GoHome() {
    return (
        <>
            <p style={{ margin: '1rem' }}>Success!</p>
            <a href="/" style={{ margin: '1rem' }}>
                Return home.{' '}
            </a>
        </>
    )
}

export default GoHome
